<template>
  <base-dialog
    :show="this.$parent.confirmDialog"
    :custom-class="customClass"
  >
    <div class="pb-44 content">
      <img
        :src="img"
        :alt="img"
      />
      <div class="font-s18 mt-4 title">
        {{ title }}
      </div>
      <div
        v-if="description"
        class="plr"
      >
        {{ description }}
      </div>
      <div class="m-0-auto mt-32">
        <div
          class="btn-theme-w88 dib"
          @click="confirmDialog"
        >
          {{ confirmBtnText }}
        </div>
        <div
          v-if="cancelBtnText"
          class="btn-default-w88 ml-32 dib"
          @click="cancelDialog"
        >
          {{ cancelBtnText }}
        </div>
      </div>
    </div>
  </base-dialog>
</template>

<script>
import BaseDialog from '@components/dialogV2';
export default {
  name: 'ConfirmDialog',
  components: { BaseDialog },
  props: {
    img: String,
    title: String,
    description: String,
    confirmBtnText: String,
    cancelBtnText: String,
    customClass: String,
  },
  methods: {
    cancelDialog() {
      this.$emit('onCancelDialog');
    },
    confirmDialog() {
      this.$emit('onConfirmDialog');
    },
  },
};
</script>

<style lang="less">
// .el-dialog__wrapper {
//   position: relative;
// }
// .el-dialog {
//   width: 420px;
//   margin-top: 0 !important;
//   top: 50%;
//   transform: translateY(-50%);

// }
  .el-dialog__body {
      padding: 0;
      text-align: center;
      .content{
        text-align: center;
        .title{
          font-weight: 600 !important;
        }
      }
  }
</style>
